import Box from '@mui/material/Box';

interface Props {
  readonly hex: string;
}

export const ColorSwatch = ({ hex }: Readonly<Props>) => (
  <Box
    component="span"
    sx={{
      bgcolor: hex,
      border: 1,
      borderColor: 'divider',
      borderRadius: '50%',
      display: 'inline-block',
      height: 16,
      mr: 1,
      verticalAlign: 'middle',
      width: 16,
    }}
  />
);
